import type { NDateLocale } from './enUS'
import { tr } from 'date-fns/locale'

const dateTrTR: NDateLocale = {
  name: 'tr-TR',
  locale: tr
}

export default dateTrTR
